import { ClassRegistrationDetail } from './class-registration-detail';
import { CourseDetail } from './course-detail';
import { TrainingCertificate } from './training-certificate';
import { Package } from './package';
import { CourseStatus } from './course-status';

/** Course. */
export class Course {
  constructor(data) {
    this.isAllowCertificate = data.isAllowCertificate;
    this.isAllowTransfer = data.isAllowTransfer;
    this.expiredDate = data.expiredDate;
    this.isCompleted = data.isCompleted;
    this.isExpired = data.isExpired;
    this.progress = data.progress;
    this.purchasedDate = data.purchasedDate;
    this.isPendingPayment = data.isPendingPayment;
    this.certificateExpiredDate = data.certificateExpiredDate;
    this.isCertificateExpired = data.isCertificateExpired;
    this.canPurchaseLaminatedCard = data.canPurchaseLaminatedCard;

    /** @type {ClassRegistrationDetail | null} */
    this.registration = data.registration;

    /** @type {TrainingCertificate | null} */
    this.trainingCertificate = data.trainingCertificate;

    /** @type {CourseDetail} */
    this.course = data.course;

    /** @type {CourseStatus["value"]} */
    this.status = data.status;

    /** @type {Package} */
    this.package = data.package;
  }
}
